<template>
  <!-- 剧集抽屉 -->
  <a-drawer
    :title="detail.name || '编辑'"
    width="700"
    :closable="false"
    :visible="visible"
    @close="onClose"
    :footer-style="{ textAlign: 'right' }"
  >
    <!-- 表单数据 -->
    <a-form
      name="form"
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 18 }"
    >
      <!-- 封面 -->
      <a-form-item
        label="封面"
        name="task_head_image"
        :rules="[{ required: true, message: '请上传' }]"
      >
        <!-- 上传组件 -->
        <Upload
          accept=".png,.jpg,.gif"
          uploadSource="ChannelAdd"
          :fileNumber="1"
          :beforeUploadPro="beforeUploadPro"
          :fileList="formState.task_head_image"
          :uploadBucket="$pub.BUCKET_PUB()"
        ></Upload>
        <div class="form-upload-list" v-if="formState.task_head_image.length">
          <ImageView
            class="form-upload-item"
            v-for="(item, index) in formState.task_head_image"
            :key="index"
            :url="$pub.CDN_URL(item.url)"
            :fileJson="item"
            @delete="touchDeleteCover('task_head_image', index)"
          >
          </ImageView>
        </div>
      </a-form-item>
      <!-- 频道 -->
      <a-form-item
        label="频道"
        name="playlet_gender"
        :rules="[{ required: true, message: '请选择' }]"
      >
        <a-select
          mode="multiple"
          v-model:value="formState.playlet_gender"
          placeholder="请选择"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        >
          <a-select-option v-for="item in DramaChannelTypes" :key="item.value" :value="item.value">{{ item.text }}</a-select-option>
        </a-select>
      </a-form-item>
      <!-- 题材 -->
      <a-form-item
        label="题材"
        name="theme_ids"
        :rules="[{ required: true, message: '请选择' }]"
      >
        <a-select
          show-search
          mode="multiple"
          v-model:value="formState.theme_ids"
          placeholder="请选择"
          :filter-option="filterOption"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        >
          <a-select-option v-for="item in themes" :key="`${item.id} - ${item.name}`" :value="item.id">{{ item.name }}</a-select-option>
        </a-select>
      </a-form-item>
      <!-- 剧情标签 -->
      <a-form-item
        label="剧情标签"
        name="tag_ids"
      >
        <a-select
          show-search
          mode="multiple"
          v-model:value="formState.tag_ids"
          placeholder="请选择"
          :filter-option="filterOption"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        >
          <a-select-option v-for="item in tags" :key="`${item.id} - ${item.name}`" :value="item.id">{{ item.name }}</a-select-option>
        </a-select>
      </a-form-item>
      <!-- 总集数 -->
      <a-form-item
        label="总集数"
        name="total_ep"
      >
        <a-input v-model:value="formState.total_ep" placeholder="请输入" />
      </a-form-item>
      <!-- 素材链接 -->
      <a-form-item
        label="素材链接"
        name="cloud_link"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-input v-model:value="formState.cloud_link" placeholder="请输入" />
      </a-form-item>
      <!-- 剧情简介 -->
      <a-form-item
        label="剧情简介"
        name="description"
      >
        <a-textarea v-model:value="formState.description" placeholder="请输入" :maxLength="1000" />
      </a-form-item>
      <!-- 评级 -->
      <a-form-item
        label="评级"
        name="grade"
      >
        <a-select
          allowClear
          v-model:value="formState.grade"
          placeholder="请选择"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        >
          <a-select-option v-for="item in DramaGradeTypes" :key="item.value" :value="item.value">{{ item.text }}</a-select-option>
        </a-select>
        <div class="grade-tags" v-if="gradeTags.length">{{ gradeTags.join('、') }}</div>
      </a-form-item>
      <!-- 上映日期 -->
      <a-form-item
        label="上映日期"
        name="release_date"
      >
        <a-date-picker v-model:value="formState.release_date" :format="dateFormat" placeholder="请选择" />
      </a-form-item>
      <!-- 权重 -->
      <a-form-item
        label="权重"
        name="weight"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-input v-model:value="formState.weight" placeholder="请输入" />
      </a-form-item>
      <!-- 上架状态 -->
      <a-form-item
        label="上架状态"
        name="status"
      >
        <a-switch
          v-model:checked="formState.status"
          checked-children="开"
          un-checked-children="关"
        />
      </a-form-item>
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
      <a-button type="primary" @click="touchSubmit">确定</a-button>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { ref, reactive, defineExpose, nextTick } from 'vue'
import { message } from 'ant-design-vue'
// import moment from 'moment'
import dayjs from 'dayjs'
import { dramaEdit, classifySelectList } from '@/api/request'
import { DramaChannelTypes, DramaGradeTypes } from '@/utils/constantList'
import Loading from '@/components/Loading'
import Upload from '@/components/Upload'
import ImageView from '@/components/ImageView'

// 日期格式
const dateFormat = 'YYYY/MM/DD';
// 回调
const emit = defineEmits('success')
// 表单实例
let RefForm = ref(null)
// 是否展示弹窗
let visible = ref(false)
// 题材
let themes = ref([])
// 标签
let tags = ref([])
// 评级标签
let gradeTags = ref([])
// 详情
let detail = ref({})
// id
let id = ref(null)
// 表单数据
let formState = reactive({
  // icon
  task_head_image: [],
  // 频道
  playlet_gender: [],
  // 题材
  theme_ids: [],
  // 剧情标签
  tag_ids: [],
  // 总集数
  total_ep: undefined,
  // 素材链接
  cloud_link: undefined,
  // 简介
  description: undefined,
  // 评级
  grade: undefined,
  // 上映日期
  release_date: undefined,
  // 权重
  weight: undefined,
  // 上架状态
  status: false,
})
// 加载
let isLoading = ref(false)

// 打开抽屉
function showDrawer (params) {
  // 展开
  visible.value = true
  // 记录
  detail.value = params
  id.value = params.id
  // 赋值
  nextTick(() => {
    if (params.id) {
      if (params.task_head_image) {
        formState.task_head_image = [{
          url: params.task_head_image
        }]
      }
      formState.playlet_gender = params.playlet_gender
      formState.theme_ids = params.theme_ids
      formState.tag_ids = params.tag_ids
      formState.total_ep = params.total_ep
      formState.cloud_link = params.cloud_link
      formState.description = params.description
      formState.weight = params.weight
      if (params.grade) {
        formState.grade = params.grade
      }
      if (params.release_date) {
        formState.release_date = dayjs(params.release_date)
      }
      gradeTags.value = []
      if (params.playlet_hot) {
        gradeTags.value.push('爆款')
      }
      if (params.high_profit_challenge) {
        gradeTags.value.push('高收益')
      }
      formState.status = params.status === 1
    }
  })
  // 初始化选择项列表
  getSelectList()
}

// 初始化选择项列表
function getSelectList () {
  classifySelectList({source: 'tag'}).then(res => {
    const { code, data } = res
    if (code === 0) {
      tags.value = data
    }
  })
  classifySelectList({source: 'theme'}).then(res => {
    const { code, data } = res
    if (code === 0) {
      themes.value = data
    }
  })
}

// 关闭弹窗
function onClose () {
  // 重置表单
  RefForm.value.resetFields()
  formState.task_head_image = []
  formState.playlet_gender = []
  formState.theme_ids = []
  formState.total_ep = undefined
  formState.cloud_link = undefined
  formState.description = undefined
  formState.grade = undefined
  formState.status = false
  visible.value = false
}

// 移除封面
function touchDeleteCover (coverKey, index) {
  formState[coverKey].splice(index, 1)
}

// 模糊匹配
function filterOption (input, option) {
  return `${option.key}`.toLowerCase().includes(`${input || ''}`.toLowerCase())
}

// 准备上传
function beforeUploadPro (file) {
  if (!file.type.includes('image')) {
    message.error('请上传图片类型的文件')
    return false
  }
  return true
}

// 提交
function touchSubmit () {
  // 手动触发表单验证
  RefForm.value.validate()
  .then(() => {
    isLoading.value = true
    dramaEdit({
      id: id.value,
      ...formState,
      status: formState.status ? 1 : 2,
      grade: formState.grade ? formState.grade : '',
      task_head_image: formState.task_head_image[0].url,
      release_date: formState.release_date ? dayjs(formState.release_date).format(dateFormat) : undefined,
    }).then(res => {
      isLoading.value = false
      const { code, msg, data } = res
      if (code === 0) {
        message.success('操作成功')
        // 更新父组件
        emit('success')
        // 关闭弹窗
        onClose()
      } else {
        message.error(res.message || msg)
      }
    })
  })
}

defineExpose({
  showDrawer
})

</script>

<style lang="less" scoped>
.form-upload-list {
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
}
.image-view.form-upload-item {
  position: relative;
  margin-top: 10px;
  margin-left: 10px;
  width: 118px;
  height: 148px;
  border-radius: 4px;
  overflow: hidden;
}
.grade-tags {
  margin-top: 10px;
  color: rgba(0, 0, 0, 0.45);
}
</style>